module.exports = __webpack_public_path__ + "static/DHCM3-62de899e80daf3a18c2210190234c235.jpg";